import React from 'react';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import RowAddColumn from '@/components/table/RowAddColumn';
import DictionaryFieldCohortFilterHeader from './DictionaryFieldCohortFilterHeader';
import { addDictionaryField } from '../../dictionaries/actions';
import { resolveCatalogueTemplate } from '../../catalogue/helper';

const DictionaryFieldTableColumns = ({
  category,
  code,
  canEdit,
  dictionaries,
  showEmptyRow,
  disabled,
  allowPmnTransfer,
  template,
}) => (
  <Table.Row>
    <UnsortedColumn columnId="field.name" colWidth={2} />
    <UnsortedColumn columnId="field.label" colWidth={2} />
    <UnsortedColumn columnId="types" colSpan={2} colWidth={3} />
    <UnsortedColumn columnId="description" colWidth={2} />
    <UnsortedColumn columnId="field.uri" colWidth={2} />
    {allowPmnTransfer && <UnsortedColumn columnId="field.pmn.rule" colWidth={2} />}
    <UnsortedColumn columnId="field.entity" colWidth={1} />
    <DictionaryFieldCohortFilterHeader
      category={category}
      code={code}
      canEdit={canEdit}
      colWidth={1}
    />
    {canEdit && dictionaries.length > 0 && (
      <RowAddColumn
        entity="dictionary"
        onClick={() => showEmptyRow(category, code, template)}
        disabled={disabled}
        colWidth={1}
      />
    )}
  </Table.Row>
);

const mapStateToProps = ({
  catalogues: { templates },
  datasets: { datasets },
}, ownProps) => {
  const { template, editable } = resolveCatalogueTemplate(datasets, templates, ownProps);
  return ({ disabled: !editable, template });
};

const mapDispatchToProps = {
  showEmptyRow: addDictionaryField,
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldTableColumns);
